import { forumId } from './forumMappers';
import { sanitizeForumHtml } from './forumContent';

export function composerValue(value = {}) {
  return { title: typeof value.title === 'string' ? value.title : '', html: sanitizeForumHtml(value.html),
    sectionId: forumId(value.sectionId), quoteId: forumId(value.quoteId),
    attachmentIds: Array.isArray(value.attachmentIds) ? [...new Set(value.attachmentIds.map(id => forumId(id)).filter(Boolean))] : [] };
}
export function composerValidation(context, value, sections, maxHtmlLength) {
  const errors = {};
  const template = document.createElement('template'); template.innerHTML = value.html;
  if (!template.content.textContent.replace(/[\s\u00a0\u200b\ufeff]/g, '') && !template.content.querySelector('img[src]')) errors.html = 'Escribe un mensaje o añade una imagen.';
  if (value.html.length > maxHtmlLength) errors.html = `El mensaje supera el límite de ${new Intl.NumberFormat('es-ES').format(maxHtmlLength)} caracteres de contenido.`;
  if (context.mode === 'create' || (context.mode === 'edit' && context.postType === 'topic')) {
    if (!value.title.trim()) errors.title = 'Escribe un título para la conversación.';
    else if ([...value.title.trim()].length > 255) errors.title = 'El título admite hasta 255 caracteres.';
  }
  if (context.mode === 'create' && !sections.some(section => section.id === value.sectionId && section.canCreate === true)) errors.sectionId = 'Elige una sección en la que puedas publicar.';
  return errors;
}
export function newForumRequestId() {
  const bytes = new Uint8Array(16); window.crypto.getRandomValues(bytes);
  // Timestamp lets the backend expire receipts without ever admitting an old
  // key as a new publication after its record has been purged.
  return Math.floor(Date.now() / 1000) + '_' + Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
}
export function publicationResult(value, context) {
  if (!value || !forumId(value.threadId) || !forumId(value.postId) || !['topic', 'comment'].includes(value.postType)) return null;
  if (context.mode !== 'create' && forumId(value.threadId) !== context.threadId) return null;
  if (context.mode === 'create' && (value.postType !== 'topic' || value.threadId !== value.postId)) return null;
  if (context.mode === 'reply' && value.postType !== 'comment') return null;
  if (context.mode === 'edit' && (value.postType !== context.postType || value.postId !== context.postId)) return null;
  return { ...value, threadId: forumId(value.threadId), postId: forumId(value.postId) };
}
